import { Button, Col, Modal, Row } from "react-bootstrap"
import SimpleLoad from "../loader/SimpleLoad"

function ModalDelete({showDelete, onHandleDelete, setShowDelete, isDeleting}){

    const handleClose = () => setShowDelete(false)

    return(
        <Modal show={showDelete} onHide={handleClose} centered className="border-0">
            <Modal.Body className="position-relative overflow-hidden">
                {isDeleting && <SimpleLoad />}
                <h5>Seguro que deseas eliminar!</h5>
                <p>No podrás deshacer esta acción</p>
                <Row className="mt-5 text-right">
                    <Col>
                        <Button
                            type="button"
                            variant="outline-secondary"
                            onClick={e=>setShowDelete(false)}
                        >Cancelar</Button>{' '}
                        <Button variant="outline-danger"
                            type="button" 
                            onClick={onHandleDelete} 
                        >Eliminar</Button>
                    </Col>
                </Row>                
            </Modal.Body>
        </Modal>
    )

}
export default ModalDelete